@if (organization && organization.id !== '') {
  <h3>eDiscovery Requests for: {{organization.name}}</h3>
} @else {
  <h3>eDiscovery Requests</h3>
}
<div class="grid-x">
  <div class="cell large-12">
    <tabs (tabClicked)="onTabClicked()">
      @if (searchRequest.statusType !== statusSearchTypes.Completed) {
        <tab title="Pending Requests">
          <ag-grid-angular class="data-grid " [gridOptions]="pendingGridOptions" [rowData]="pendingData | async" aria-label="Pending Requests"></ag-grid-angular>
        </tab>
      }
      @if (searchRequest.statusType !== statusSearchTypes.Pending) {
        <tab title="Completed Requests">
          <ag-grid-angular class="data-grid " [gridOptions]="completedGridOptions" [rowData]="completedData | async" aria-label="Completed Requests"></ag-grid-angular>
        </tab>
      }
    </tabs>
  </div>
</div>

